import Lettuce from "./lettuce";

module.exports = Lettuce;
